module.exports = __webpack_public_path__ + "media/bootstrap-icons/border-right-5083066a.svg";